import * as React from "react";
import clsx from "clsx";
import { BreadcrumbsItem } from "./breadcrumbs-item.mjs";
const Breadcrumbs = (props) => {
  const { className, items, theme, ...rest } = props;
  return /* @__PURE__ */ React.createElement("nav", { ...rest, className: clsx("breadcrumbs", className), "data-theme": theme }, /* @__PURE__ */ React.createElement("ol", { className: "breadcrumbs__list" }, items.map((item, index) => {
    var _a;
    return /* @__PURE__ */ React.createElement(BreadcrumbsItem, { key: (_a = item.id) != null ? _a : index, ...item });
  })));
};
export {
  Breadcrumbs
};
